import { styled } from '@styles/stitches';

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  transition: 'opacity 0.3s ease-in-out',
});

export const Overlay = styled('div', {
  position: 'fixed',
  top: 0,
  inset: 0,
  zIndex: 1000,
  backgroundColor: '$primaryBackground',
});

export const Content = styled('div', {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:focus': {
    outline: 0,
  },
});
